define('modules/editor/views/property_boxes/action',['require','exports','module','./base','ldsh!../../templates/property_boxes/action'],function (require, exports, module) {
  "use strict";
  var Base = require("./base");
  module.exports = Base.extend({
    template: require("ldsh!../../templates/property_boxes/action")
  });
});
